const CustomerAccountsResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'customeraccounts/',
        apiRequestParams.defaults(),
        {
            get: {
                url: appConfig.apiBaseUrl + 'customeraccounts/:accountID',
            },
        }
    );
};

module.exports = CustomerAccountsResource;
